import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1)
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { for: "currentPassword" }
const _hoisted_4 = { for: "newPassword" }
const _hoisted_5 = { for: "confirmPassword" }
const _hoisted_6 = {
  key: 0,
  style: {"color":"red","font-size":"12px","position":"absolute","margin":"0","padding":"0"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "grayWide margin-30" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("change_password.title")), 1),
    _hoisted_1,
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("span", {
            class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.current_password }])
          }, [
            _createVNode(_component_Password, {
              id: "currentPassword",
              toggleMask: true,
              modelValue: _ctx.form.current_password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.current_password) = $event)),
              feedback: false,
              name: "currentPassword"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("change_password.old_password")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.errors.current_password), 1)
          ], 2)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("span", {
            class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.password }])
          }, [
            _createVNode(_component_Password, {
              id: "newPassword",
              toggleMask: true,
              modelValue: _ctx.form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
              name: "newPassword"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("change_password.new_password")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.errors.password), 1)
          ], 2)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("span", {
            class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.password_confirmation }])
          }, [
            _createVNode(_component_Password, {
              id: "confirmPassword",
              toggleMask: true,
              modelValue: _ctx.form.password_confirmation,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.password_confirmation) = $event)),
              name: "confirmPassword"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("change_password.confirm_password")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.errors.password_confirmation), 1)
          ], 2)
        ])
      ]),
      (_ctx.errors.something_wrong)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errors.something_wrong), 1))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createVNode(_component_Button, {
        onClick: _withModifiers(_ctx.putPassword, ["prevent"]),
        class: "defaultButton whiteBG margin-0",
        label: _ctx.$t(`change_password.save_changes`)
      }, null, 8, ["onClick", "label"])
    ]),
    _createVNode(_component_router_link, {
      to: { name: 'MyProfile' },
      class: "cancel"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
      ]),
      _: 1
    })
  ]))
}